import { ElectionPageParams } from "@/src/common/types"
import { raceIsRepresentative } from "@/src/common/utils"
import {
  ELECTION_API_REDESIGN_DATE,
  REVALIDATE
} from "@/src/elections/business-layer/config"
import { URL_SLUG_TO_RACE_HASH_MAP } from "@/src/elections/business-layer/constants"
import {
  BaseElectionTemplateProps,
  MapTemplateProps
} from "@/src/elections/business-layer/types"
import { GetElectionPropsUsecase } from "@/src/elections/business-layer/usecases"
import ElectionTemplate from "@/src/elections/components/ElectionTemplate"
import {
  ElectionsAPIInstance,
  ExternalHTTPInstance
} from "@/src/elections/data-layer"
import stateHouse from "@/src/elections/data-layer/geojson/state-houses-of-assembly.json"
import { FeatureCollection } from "geojson"
import type {
  GetStaticPropsContext,
  GetStaticPropsResult,
  NextPage
} from "next"

const StateRaceSummary: NextPage<BaseElectionTemplateProps> = (
  props: BaseElectionTemplateProps
) => {
  const mapProps = {
    ...props.mapProps,
    appendStateName: true,
    mapFeatures: stateHouse as FeatureCollection
  } as MapTemplateProps

  return (
    <ElectionTemplate
      templateProps={{ ...props, mapProps }}
      electionsAPI={ElectionsAPIInstance}
      externalHTTP={ExternalHTTPInstance}
    />
  )
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking"
  }
}

export async function getStaticProps(
  context: GetStaticPropsContext<ElectionPageParams>
): Promise<GetStaticPropsResult<BaseElectionTemplateProps>> {
  const state = context.params?.state
  const year = context.params?.year as string
  const raceUrlSlug = "state-houses-of-assembly"
  const race = URL_SLUG_TO_RACE_HASH_MAP[raceUrlSlug]

  const getElectionPropsUsecase = new GetElectionPropsUsecase()
  const props = await getElectionPropsUsecase.execute(
    raceUrlSlug,
    state,
    raceIsRepresentative(race)
      ? "constituency_code"
      : new Date(year) < new Date(ELECTION_API_REDESIGN_DATE)
      ? "state_code"
      : "lga_code",
    year
  )
  if (!props.activeState) {
    return {
      notFound: true
    }
  } else {
    return {
      revalidate: REVALIDATE,
      props
    }
  }
}

export default StateRaceSummary
